import { Reveal } from "../../../motion";

/**
 * Explains why Flywire declined the quotation charge (CQ).
 *
 * The Flywire "failed" webhook stores the decline on the quotation itself:
 * - clientReason: Flywire's short explanation (e.g. "Refused. Not retry")
 * - reason / reasonCode: the full bank message and code, which support quotes back to Flywire
 *
 * Mirrors the "Charge Failed" block on the booking detail page (PaymentDetail.js).
 */
const ChargeFailedNotice = ({ quotation }) => {
  if (quotation?.paymentStatus !== "CHARGE_FAILED") return null;

  const clientReason = quotation?.clientReason || "";
  const flywireDetail = [quotation?.reason, quotation?.reasonCode]
    .filter(Boolean)
    .join(" · ");

  return (
    <Reveal
      onMount
      y={8}
      className="tw:mb-4 tw:overflow-hidden tw:rounded-[5px] tw:border tw:border-[#F3C7C3] tw:bg-[#FDF5F4]"
      data-testid="quotation-charge-failed-notice"
    >
      <div className="tw:flex tw:flex-col tw:gap-4 tw:p-4 tw:md:flex-row tw:md:items-start">
        <div className="tw:w-[180px] tw:flex-shrink-0 tw:font-hanken-grotesk tw:text-[15px] tw:font-[700] tw:text-[#B3261E]">
          Charge Failed
        </div>
        <div className="tw:flex tw:flex-1 tw:flex-col tw:gap-2 tw:font-hanken-grotesk tw:text-[14px] tw:leading-[20px] tw:text-[#6B2C27]">
          <div>
            Flywire declined the payment for this quotation. No payment has been collected.
          </div>
          {clientReason && (
            <div>
              <span className="tw:text-[#8D8D8D]">Reason: </span>
              {clientReason}
            </div>
          )}
          {flywireDetail && (
            <div className="tw:text-[13px]">
              <span className="tw:text-[#8D8D8D]">Flywire detail: </span>
              {flywireDetail}
            </div>
          )}
          {/* Older failed quotations were saved before the reason was stored. */}
          {!clientReason && !flywireDetail && (
            <div className="tw:text-[13px] tw:text-[#8D8D8D]">
              Flywire did not send a reason for this decline.
            </div>
          )}
        </div>
      </div>
    </Reveal>
  );
};

export default ChargeFailedNotice;
